import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form, Input, InputNumber, message } from 'antd'
import { formRules } from 'utils'
import { Service } from 'services'

const EditModal = props => {
    const { baseValues, onSubmit, visible, onClose } = props
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const rules = formRules(t)

    useEffect(() => {
        if (!baseValues) return

        form.setFieldsValue({
            position: baseValues.position,
            url: baseValues.url,
        })
    }, [baseValues])

    const handleFormSubmit = () => {
        form.validateFields()
            .then(values => {
                return Service.update.emailAttachment(baseValues.id, {
                    email_attachment: {
                        position: values.position,
                        url: values.url,
                    },
                })
            })
            .then(result => {
                message.success(t('general.feedback.update.title'))
                onSubmit(result)
                onClose()
            })
            .catch(err => {
                console.log(err)
                message.error(t('general.feedback.error.title'))
            })
    }

    return (
        <Modal
            title={t('attachment_page.edit_title')}
            visible={visible}
            onCancel={onClose}
            width='50%'
            footer={[
                <Button key='close' type='primary' onClick={onClose}>
                    {t('general.actions.cancel')}
                </Button>,
                <Button key='submit' type='primary' htmlType='submit' form='attachmentEditForm'>
                    {t('general.actions.submit')}
                </Button>,
            ]}
        >
            <article className='analysis-form'>
                <Form
                    form={form}
                    id='attachmentEditForm'
                    layout='vertical'
                    onFinish={handleFormSubmit}
                >
                    <div className='fields'>
                        <Form.Item
                            name='position'
                            label={t('attachment_page.position')}
                            rules={[rules.required]}
                        >
                            <InputNumber min={1} />
                        </Form.Item>

                        <Form.Item
                            name='url'
                            label={t('attachment_page.url')}
                            rules={[rules.required, rules.url]}
                            style={{ flexBasis: '100%' }}
                        >
                            <Input placeholder='https://' />
                        </Form.Item>
                    </div>
                </Form>
            </article>
        </Modal>
    )
}

export default EditModal
